module.exports = __webpack_public_path__ + "static/media/hidefilter.1e54e2d4.svg";